import { BackToSettingsButton } from "@/setup/connect/settings-connect-layout"
import { ConnectKehePage } from "@/setup/connect/kehe/page"
import { ConnectKeheFreshdeskPage } from "@/setup/connect/kehe/freshdesk-page"
import { ConnectAholdPage } from "@/setup/connect/ahold/page"
import { ConnectCandsPage } from "@/setup/connect/cands/page"
import { ConnectCandsDisputePortalPage } from "@/setup/connect/cands/dispute-portal-page"
import { ConnectSvHarborPage } from "@/setup/connect/sv-harbor/page"
import { ConnectAmazonPage } from "@/setup/connect/amazon/page"
import { ConnectWalmartPage } from "@/setup/connect/walmart/page"
import { ConnectWalmartHighRadiusPage } from "@/setup/connect/walmart-highradius/page"
import { ConnectSpinsPage } from "@/setup/connect/spins/page"
import { ConnectHyVeePage } from "@/setup/connect/hyvee/page"
import { ConnectKrogerPage } from "@/setup/connect/kroger/page"
import { ConnectBozzutosPage } from "@/setup/connect/bozzutos/page"
import { ConnectDotFoodsPage } from "@/setup/connect/dotfoods/page"
import { ConnectSpsPage } from "@/setup/connect/sps/page"
import { ConnectStordPage } from "@/setup/connect/stord/page"
import { ConnectTargetPage } from "@/setup/connect/target/page"
import { ConnectWakefernPage } from "@/setup/connect/wakefern/page"
import { ConnectAwgPage } from "@/setup/connect/awg/page"
import { ConnectRoadtexPage } from "@/setup/connect/roadtex/page"
import { ConnectVividlyPage } from "@/setup/connect/vividly/page"
import { ConnectHebPage } from "@/setup/connect/heb/page"
import { ConnectTonysFinefooodsPage } from "@/setup/connect/tonysfinefoods/page"
import { ConnectUnfiPage } from "@/setup/connect/unfi/page"
import { NewConnectionPage } from "@/setup/connect/new/page"

export function SettingsConnectKehePage() {
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <ConnectKehePage redirectTo="/settings/connect/kehe-freshdesk" />
    </div>
  )
}

export function SettingsConnectKeheFreshdeskPage() {
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <ConnectKeheFreshdeskPage
        redirectTo="/settings/config/kehe"
        keheConnectPath="/settings/connect/kehe"
      />
    </div>
  )
}

export function SettingsConnectAholdPage() {
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <ConnectAholdPage redirectTo="/settings/connect" />
    </div>
  )
}

export function SettingsConnectCandsPage() {
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <ConnectCandsPage redirectTo="/settings/connect/cands-dispute-portal" />
    </div>
  )
}

export function SettingsConnectCandsDisputePortalPage() {
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <ConnectCandsDisputePortalPage
        redirectTo="/settings/config/cands"
        candsConnectPath="/settings/connect/cands"
      />
    </div>
  )
}

export function SettingsConnectSvHarborPage() {
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <ConnectSvHarborPage redirectTo="/settings/connect" />
    </div>
  )
}

export function SettingsConnectAmazonPage() {
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <ConnectAmazonPage redirectTo="/settings/connect" />
    </div>
  )
}

export function SettingsConnectWalmartPage() {
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <ConnectWalmartPage redirectTo="/settings/connect" />
    </div>
  )
}

export function SettingsConnectSpinsPage() {
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <ConnectSpinsPage redirectTo="/settings/connect" />
    </div>
  )
}

export function SettingsConnectWalmartHighRadiusPage() {
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <ConnectWalmartHighRadiusPage redirectTo="/settings/connect" />
    </div>
  )
}

export function SettingsConnectHyVeePage() {
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <ConnectHyVeePage redirectTo="/settings/connect" />
    </div>
  )
}

export function SettingsConnectKrogerPage() {
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <ConnectKrogerPage redirectTo="/settings/connect" />
    </div>
  )
}

export function SettingsConnectBozzutosPage() {
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <ConnectBozzutosPage redirectTo="/settings/connect" />
    </div>
  )
}

export function SettingsConnectDotFoodsPage() {
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <ConnectDotFoodsPage redirectTo="/settings/connect" />
    </div>
  )
}

export function SettingsConnectSpsPage() {
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <ConnectSpsPage redirectTo="/settings/connect" />
    </div>
  )
}

export function SettingsConnectStordPage() {
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <ConnectStordPage redirectTo="/settings/connect" />
    </div>
  )
}

export function SettingsConnectTargetPage() {
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <ConnectTargetPage redirectTo="/settings/connect" />
    </div>
  )
}

export function SettingsConnectWakefernPage() {
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <ConnectWakefernPage redirectTo="/settings/config/wakefern" />
    </div>
  )
}

export function SettingsConnectAwgPage() {
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <ConnectAwgPage redirectTo="/settings/connect" />
    </div>
  )
}

export function SettingsConnectRoadtexPage() {
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <ConnectRoadtexPage redirectTo="/settings/connect" />
    </div>
  )
}

export function SettingsConnectVividlyPage() {
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <ConnectVividlyPage redirectTo="/settings/connect" />
    </div>
  )
}

export function SettingsConnectHebPage() {
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <ConnectHebPage redirectTo="/settings/connect" />
    </div>
  )
}

export function SettingsConnectTonysFinefooodsPage() {
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <ConnectTonysFinefooodsPage redirectTo="/settings/connect" />
    </div>
  )
}

export function SettingsConnectUnfiPage() {
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <ConnectUnfiPage redirectTo="/settings/config/unfi" />
    </div>
  )
}

export function SettingsNewConnectionPage() {
  return (
    <div class="px-4">
      <BackToSettingsButton />
      <NewConnectionPage redirectTo="/settings/connect" />
    </div>
  )
}
